<template>
  <BRow>
    <BCol cols="3">
      <p class="font-weight-bolder">تاریخ شروع جلسه</p>
    </BCol>
    <BCol cols="3">
      <p class="font-weight-bolder">تاریخ پایان جلسه</p>
    </BCol>
    <BCol cols="3">
      <p class="font-weight-bolder">جلسه فعال است؟</p>
    </BCol>
    <BCol cols="3">
      <p class="font-weight-bolder">لینک جلسه</p>
    </BCol>
    <BCol cols="12" class="mt-0">
      <hr class="mt-0" />
    </BCol>
    <ObserveListDetailsSectionContent
      v-for="(schedule, index) in scheduleDetails.schedules"
      :key="index"
      :scheduleDetails="schedule"
    ></ObserveListDetailsSectionContent>
    <hr />
  </BRow>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    scheduleDetails: {
      type: Object,
    },
  },
  components: {
    BRow,
    BCol,
    ObserveListDetailsSectionContent,
  },
};
import ObserveListDetailsSectionContent from "@/views/components/Observe/ObserveListDetailsSectionContent.vue";
import { BRow, BCol } from "bootstrap-vue";
</script>
